import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Select from 'react-select';
import moment from 'moment';
import { connect } from 'react-redux';

import { closeProjectForm, saveProject } from '../../store/modules/project';

import PeoplePicker from '../../components/PeoplePicker/PeoplePicker';
import CompanyPicker from '../../components/CompanyPicker/CompanyPicker';
import NumberRangePicker from '../../components/NumberRangePicker/NumberRangePicker';
import mergeStates from '../../helpers/mergeStates';

import SimplWysiwyg from '../SimplWysiwyg/SimplWysiwyg';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import FormFileUpload from '../FormFileUpload/FormFileUpload';
import FormTasks from '../FormTasks/FormTasks';
import { RaisedButton } from 'material-ui';
import ProjectPicker from '../ProjectPicker/ProjectPicker';

const mapActionCreators = {
  saveProject,
  closeProjectForm,
};

const mapStateToProps = state => ({
  project: state.project.projects[state.project.formTarget],
  formTarget: state.project.formTarget,
  fetching: state.project.fetching,
  open: state.project.formOpen,
  user: state.login.user,
  staff: state.login.staff,
  myCompany: state.login.myCompany,
  tasks: _.pick(
    state.task.tasks,
    state.project.projects[state.project.current]
      ? state.project.projects[state.project.current].tasks
      : null,
  ),
  files: _.filter(
    _.pick(
      state.file.files,
      state.project.projects[state.project.formTarget]
        ? state.project.projects[state.project.formTarget].files
        : {},
    ),
    ['deleted_at', null],
  ),
});

const initialState = {
  start_date: moment(),
  end_date: null,
  company_id: null,
  id: null,
  description: '',
  start: moment().format('YYYY-MM-DD'),
  end: null,
  name: '',
  project_leader: null,
  wtf: null,
  status: 'open',
  files: [],
  tasks: [],
  project_id: null,
  number_range: null,
  project_number: null,
  isABlueprint: false,
};

class FormProject extends React.Component {
  constructor(props) {
    super(props);

    const companyId =
      typeof props.myCompany.id === 'undefined' ? null : props.myCompany.id;

    let id = null;
    if (
      typeof props.user !== 'undefined' &&
      props.user !== null &&
      typeof props.user.currentStaffId !== 'undefined' &&
      props.user.currentStaffId.length !== 0
    ) {
      id = props.user.currentStaffId;
    }

    const nextState = _.extend(initialState, {
      project_leader: id,
      company_id: companyId,
    });

    // // console.log(JSON.stringify(nextState));

    this.state = _.cloneDeep(nextState);

    this.receivedProps = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open === false && nextProps.open === true) {
      // form gets opened
      setTimeout(() => this.focus(), 150);

      if (window.simplPreselection.company !== null) {
        this.setState({
          company_id: window.simplPreselection.company,
        });
        window.simplPreselection.company = null;
      } else {
        this.setState({
          company_id:
            typeof nextProps.myCompany.id === 'undefined'
              ? null
              : nextProps.myCompany.id,
        });
      }

      if (window.simplPreselection.project !== null) {
        this.setState({
          project_id: window.simplPreselection.project,
        });

        window.simplPreselection.project = null;
      }
    }

    if (
      typeof this.state.project_leader === 'undefined' ||
      this.state.project_leader === null
    ) {
      this.setState({
        project_leader: nextProps.user.currentStaffId,
      });
    }

    // this.setState({
    //   project_leader: nextProps.user.currentStaffId
    // });

    if (
      typeof nextProps.formTarget !== 'undefined' &&
      nextProps.formTarget !== null &&
      this.receivedProps === false
    ) {
      // editing a form, not received any props yet
      if (
        typeof nextProps.project !== 'undefined' &&
        nextProps.project !== null
      ) {
        let omittedFields = ['tasks'];
        const project = _.clone(nextProps.project);

        if (window.simplPreselection.usAsBlueprint === true) {
          this.setState({
            isABlueprint: true,
          });

          omittedFields.push('id');
          omittedFields.push('files');
          project.name = `Kopie von ${project.name}`;
        }

        this.setState(_.omit(project, omittedFields));

        const tasks = [];
        let taskId = 0;

        _.forOwn(nextProps.tasks, task => {
          if (typeof task !== 'string') {
            if (window.simplPreselection.usAsBlueprint === true) {
              let newTask = _.omit(task, [
                'id',
                'is_done',
                'done_at',
                'done_by',
                'due_date',
                'taskable',
                'taskable_id',
                'taskable_type',
                'connected',
                'end_date',
                'end',
              ]);
              newTask.id = `temp_task_${Date.now()}${taskId}`;
              taskId++;
              tasks.push(newTask);
            } else {
              tasks.push(task);
            }
          }
        });

        this.setState({
          tasks,
        });

        if (window.simplPreselection.usAsBlueprint === false) {
          this.setState({
            files: Object.keys(nextProps.files).map(
              key => nextProps.files[key],
            ),
          });
        }

        this.receivedProps = true;
      }

      if (nextProps.tasks !== null) {
        if (
          Object.keys(this.props.tasks).length !==
          Object.keys(nextProps.tasks).length
        ) {
          const tasks = [];

          _.forOwn(nextProps.tasks, task => {
            if (typeof task !== 'string') {
              tasks.push(task);
            }
          });

          this.setState({
            tasks,
          });
        }
      }

      window.simplPreselection.usAsBlueprint = false;
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (
      JSON.stringify(
        _.omit(nextProps, [
          'saveProject',
          'closeProjectForm',
          'setProjectForm',
          'deleteProject',
          'push',
        ]),
      ) !==
      JSON.stringify(
        _.omit(this.props, [
          'saveProject',
          'closeProjectForm',
          'setProjectForm',
          'deleteProject',
          'push',
        ]),
      )
    ) {
      return true;
    }

    return false;
  }

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  setStatus = value => {
    this.setState({ status: value.value });
  };

  resetState = () => {
    this.setState({
      ...initialState,
      responsible_user: this.props.user.currentStaffId,
      project_leader: this.props.user.currentStaffId,
    });
    this.receivedProps = false;
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  save = () => {
    // // console.log('saving!', this.state);
    this.props.saveProject({ ...this.state });
    this.resetState();
    this.props.closeProjectForm();
  };

  renderNumberRangePicker = () => {
    if (
      typeof this.state.id === 'undefined' ||
      this.state.id === null ||
      (this.state.id !== null && this.state.project_number === null)
    ) {
      return (
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="number_range">
              Nummernkreis
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <NumberRangePicker
              name="number_range"
              showEmptyMessage
              default={this.state.number_range}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
      );
    }

    if (
      this.state.project_number !== null &&
      this.state.project_number.length
    ) {
      return (
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label">Nummer</label>
          </div>
          <div className="col-xs-12 col-sm-8">{this.state.project_number}</div>
        </div>
      );
    }

    return null;
  };

  renderBluePrintInfo = () => {
    if (this.state.isABlueprint) {
      return (
        <div className="infoMessage">
          Dieses Projekt wird aus einer Vorlage erzeugt: Infos wie Beschreibung,
          Zuständige und Aufgaben werden kopiert, Aktivitäten und Dateien jedoch
          nicht.
        </div>
      );
    }

    return null;
  };

  render() {
    const props = this.props;

    const opened = typeof props.open !== 'undefined' ? props.open : false;

    let buttonText = 'Erstellen';
    if (this.state.id !== null) {
      buttonText = 'Speichern';
    }

    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.resetState();
          props.closeProjectForm();
        }}
      />,
      <RaisedButton
        style={{ marginLeft: 10 }}
        label={buttonText}
        primary
        disabled={this.state.name.trim().length === 0}
        onMouseDown={() => this.save()}
      />,
    ];

    const statusOptions = [
      {
        value: 'open',
        title: 'Offen',
        label: 'Offen',
      },
      {
        value: 'closed',
        title: 'Abgeschlossen',
        label: 'Abgeschlossen',
      },
    ];

    const timeLabel = this.state.end_date ? 'Zeitraum' : 'Projektstart';

    let title = 'Neues Projekt erstellen';
    if (this.state.id !== null) {
      title = `"${this.state.name}" bearbeiten`;
    } else if (this.state.name.length) {
      title = `"${this.state.name}" erstellen`;
    }

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open={opened}
        autoScrollBodyContent
        className="form modal-center"
        contentClassName="form-container form-container--project"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        {this.renderBluePrintInfo()}
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="name">
              Projektname
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="name"
              required
              value={this.state.name}
              onChange={e => this.handleChange(e)}
              ref={input => {
                this.primaryInput = input;
              }}
            />
          </div>
        </div>
        {this.renderNumberRangePicker()}
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Hauptprojekt
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <ProjectPicker
              name="project_id"
              default={this.state.project_id}
              omit={this.state.id}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Unternehmen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <CompanyPicker
              name="company_id"
              clearable={false}
              onChange={e => this.handleChange(e)}
              default={this.state.company_id}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Projektleiter
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <PeoplePicker
              type="staff"
              name="project_leader"
              clearable={false}
              value={this.state.project_leader}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Status
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <Select
              onChange={this.setStatus}
              name="status"
              options={statusOptions}
              placeholder="Projektstatus"
              value={this.state.status}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="start-time">
              {timeLabel}
            </label>
          </div>
          <div className="col-xs-12 col-sm-3">
            <SimplDatepicker
              defaultValue={this.state.start}
              dateFormat="DD.MM.YYYY"
              onChange={(date, momentDate) => {
                this.setState({ start: date, start_date: momentDate });

                if (moment(this.state.end).isSameOrBefore(momentDate)) {
                  this.setState({ end: date });
                }
              }}
            />
          </div>
          <div className="col-xs-12 col-sm-1 text-center flex-vcenter">bis</div>
          <div className="col-xs-12 col-sm-3">
            <SimplDatepicker
              defaultValue={this.state.end}
              dateFormat="DD.MM.YYYY"
              onChange={(date, moment) => {
                this.setState({ end: date, end_date: moment });
              }}
              minDate={this.state.start}
              right
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="description">
              Bemerkungen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <SimplWysiwyg
              content={this.state.description}
              onUpdate={content => this.setState({ description: content })}
            />
          </div>
        </div>

        <hr />

        <FormTasks
          tasks={this.state.tasks}
          onUpdate={tasks => this.setState({ tasks })}
        />

        <hr />

        <FormFileUpload
          files={this.state.files}
          onUpdate={files => this.setState({ files })}
        />
      </Dialog>
    );
  }
}

FormProject.propTypes = {
  saveProject: PropTypes.func.isRequired,
  closeProjectForm: PropTypes.func.isRequired,
  setProjectForm: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  deleteProject: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  formTarget: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]), // eslint-disable-line react/no-unused-prop-types
  push: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  user: PropTypes.object.isRequired,
  myCompany: PropTypes.object,
  open: PropTypes.bool,
  tasks: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  files: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
  project: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};

export default connect(mapStateToProps, mapActionCreators)(FormProject);



// WEBPACK FOOTER //
// ./src/components/FormProject/FormProject.js